<template>
  <div class="jumbotron">
  </div>
</template>
<script>
export default {
  name: 'sui-footer'
}
</script>
<style scoped>
.jumbotron {
    margin-bottom: 0px;
    margin-top: 5rem;
    width: 100%;
}
</style>
